import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupListRoute from "./routes/YearGroupListWrapper";
import TranscriptRecordsRoute from "./routes/TranscriptRecords";

export default store => ({
  path: "prepare-data",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-prepare-data" */ "./components"
    ).then(m => m.default)
  ),

  childRoutes: [YearGroupListRoute(store), TranscriptRecordsRoute(store)],
});
